import React from "react";

const SIZES = {
  xs: "w-7 h-7 text-[9px]",
  sm: "w-10 h-10 text-xs",
  md: "w-14 h-14 text-sm",
  lg: "w-20 h-20 text-base",
  xl: "w-28 h-28 text-lg",
  "2xl": "w-40 h-40 text-3xl",
  "3xl": "w-56 h-56 text-5xl",
};

function initials(name = "") {
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

/**
 * Freigestellter Spieler-Kopf als runder Avatar. Fällt auf Initialen zurück.
 * photoUrl: transparent PNG (chronik cutout). name: für Fallback + optionales Label.
 */
export const PlayerAvatar = ({ photoUrl, name, size = "md", showName = false, className = "", nameClassName = "" }) => {
  const sizeCls = SIZES[size] || SIZES.md;
  return (
    <div className={`flex flex-col items-center gap-1 ${className}`} data-testid="player-avatar">
      <div
        className={`${sizeCls} rounded-full overflow-hidden flex items-center justify-center bg-gradient-to-b from-white/15 to-white/5 ring-2 ring-white/20 shrink-0`}
      >
        {photoUrl ? (
          <img
            src={photoUrl}
            alt={name || "Spieler"}
            className="w-full h-full object-cover object-top"
            loading="lazy"
            draggable={false}
          />
        ) : (
          <span className="font-bold text-white/80">{initials(name)}</span>
        )}
      </div>
      {showName && (
        <span className={`text-center leading-tight truncate max-w-full ${nameClassName || "text-xs text-white/80"}`}>
          {name}
        </span>
      )}
    </div>
  );
};

export default PlayerAvatar;
